<fe-header></fe-header>
<main>
    <fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>
    <fe-delivery-cancel-parent></fe-delivery-cancel-parent>
    <fe-reservation-parent></fe-reservation-parent>
    <fe-location-detail
        [displayPrecheckin]="
            reservationDetails?.data?.reservationDetails?.currency === 'MXN'
        "
    ></fe-location-detail>
    <fe-car-rental-policy
        [crpInternational]="crpInternational"
    ></fe-car-rental-policy>
</main>
<fe-footer></fe-footer>
